import React, { CSSProperties, FC } from 'react';
import {
  WrapperDialog,
  WrapperDialogAction,
  WrapperDialogButtonA,
  WrapperDialogButtonB,
  WrapperDialogClose,
  WrapperDialogContent,
  WrapperExtraImage
} from './styled';
import { GlobalStyles } from '../../components/LightBox';

interface IProps {
  img?: any;
  maxWidth: string;
  persistence?: boolean;
  show?: boolean;
  style?: CSSProperties;
  styleActions?: CSSProperties;
  textButtonA?: string;
  textButtonB?: string;
  zIndex: number;
  handlerButtonA?: () => void;
  handlerButtonB?: () => void;
  handlerClose: () => void;
}

const Dialog: FC<IProps> = ({
  children,
  img,
  maxWidth,
  persistence,
  show,
  style,
  styleActions,
  textButtonA,
  textButtonB,
  zIndex,
  handlerButtonA,
  handlerButtonB,
  handlerClose
}) => {
  const closeController = (locked: boolean) => {
    if (locked && persistence) return;
    handlerClose();
  };

  return (
    <WrapperDialog
      data-testid="cmp-dialog-wrapper"
      onClick={() => closeController(true)}
      show={show}
      style={style}
      zIndex={zIndex}
      className={show ? 'show' : ''}
    >
      {show && <GlobalStyles />}
      <WrapperDialogContent
        data-testid="cmp-dialog-content"
        show={show}
        maxWidth={maxWidth}
        onClick={(e) => e.stopPropagation()}
      >
        <WrapperDialogClose
          data-testid="cmp-dialog-button"
          onClick={() => closeController(false)}
        />
        {img && (
          <WrapperExtraImage>
            <img src={img} alt="img" />
          </WrapperExtraImage>
        )}
        {show ? children : ''}
        {(textButtonA || textButtonB) && (
          <WrapperDialogAction style={styleActions}>
            {textButtonA && (
              <WrapperDialogButtonA
                data-testid="cmp-dialog-button-a"
                onClick={() => {
                  if (handlerButtonA) handlerButtonA();
                }}
              >
                {textButtonA}
              </WrapperDialogButtonA>
            )}
            {textButtonB && (
              <WrapperDialogButtonB
                data-testid="cmp-dialog-button-b"
                onClick={() => {
                  if (handlerButtonB) handlerButtonB();
                }}
              >
                {textButtonB}
              </WrapperDialogButtonB>
            )}
          </WrapperDialogAction>
        )}
      </WrapperDialogContent>
    </WrapperDialog>
  );
};

export default Dialog;
